import {
    Button,
    ListItem,
    Box
} from '@mui/material';

import {
    useNavigate,
    useLocation
} from 'react-router-dom';

import { useState } from 'react';

import FilePresentIcon from '@mui/icons-material/FilePresent';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { ExpandMore, ExpandLess } from '@mui/icons-material';

const iconMap = {
    DataSources: <FilePresentIcon />,
    AnalyticConsole: <AssessmentIcon />
}

const activeStyle = {
    color: '#ff5d00 !important',
    backgroundColor: 'rgba(255, 93, 0, 0.1)',
    '& svg': { color: '#ff5d00 !important' }
};

const MenuListItem = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const {
        icon,
        route,
        style,
        size,
        sx,
        title,
        variant,
        children,
        expanded,
        onExpand
    } = props;

    const isActive = route && location.pathname === route;
    const isParentActive = children?.some(child => child.route && location.pathname === child.route);

    return (
        <Box>
            <ListItem key={route}>
                <Button
                    key={route}
                    style={style}
                    sx={{ ...sx, ...((isActive || isParentActive) ? activeStyle : {}) }}
                    size={size}
                    variant={variant}
                    onClick={children ? onExpand : () => navigate(route)}
                    startIcon={icon}
                >
                    {title}
                    {children && (
                        <Box sx={{ ml: 'auto' }}>
                            {expanded ? <ExpandMore /> : <ExpandLess />}
                        </Box>
                    )}
                </Button>
            </ListItem>

            {expanded && children?.map((child) => {
                const isChildActive = child.route && location.pathname === child.route;
                return (
                    <ListItem key={child.title}>
                        <Button onClick={() => navigate(child.route)}
                            sx={{
                                fontSize: '14px',
                                color: isChildActive ? '#ff5d00' : 'rgba(255, 255, 255, 0.7)',
                                width: '100%',
                                borderRadius: '10px',
                                backgroundColor: isChildActive ? 'rgba(255, 93, 0, 0.1)' : 'transparent',
                                fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
                                textTransform: 'none',
                                '& svg': isChildActive ? { color: '#ff5d00 !important' } : {},
                                '&:hover': {
                                    backgroundColor: 'rgba(255, 255, 255, 0.06)',
                                    color: '#ff5d00 !important',
                                    '& svg': {
                                        color: '#ff5d00 !important'
                                    }
                                }
                            }}>
                            {child.icon && <Box sx={{
                                mr: '9px',
                                color: isChildActive ? '#ff5d00' : 'rgba(255, 255, 255, 0.3)'
                            }}>{iconMap[child.icon]}</Box>}
                            {child.title}
                        </Button>
                    </ListItem>
                );
            })}
        </Box>
    );
};

export default MenuListItem;